/* eslint-disable @typescript-eslint/no-explicit-any */
import { ReactNode } from 'react';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { Options } from "@contentful/rich-text-react-renderer";
import { v4 as uuidv4 } from 'uuid';
import parse from 'html-react-parser';

// @ts-ignore Convert to TS https://pc-technology.atlassian.net/browse/PCIPS-1987
import { parseProviderName, parseProviderPhoneNumber } from '../utils';

const defaultOptions = {
  renderText: (text: string, replacements: Replacements) => {
    // Apply the provider name and phone number replacements if provided
    let updatedText = text;
    if (replacements?.providerName) {
      updatedText = parseProviderName(updatedText, replacements.providerName);
    }
    if (replacements?.providerPhoneNumber) {
      updatedText = parseProviderPhoneNumber(updatedText, replacements.providerPhoneNumber);
    }

    // Split the updated text on newline characters and wrap with <br> tags where necessary
    return updatedText?.split('\n').reduce((children: ReactNode[], textSegment: string, index: number) => [
      ...children,
      index > 0 && <br key={uuidv4()} />,
      parse(textSegment),
    ], []);
  },
};

interface Replacements {
  providerPhoneNumber?: string;
  providerName?: string;
}

const RichText = ({ document, options, replacements }:
  { document: any, options: Options, replacements?: Replacements }) => {
  // Create a new options object that passes the replacements to renderText
  const mergedOptions = {
    ...options,
    renderText: (text: string) => defaultOptions.renderText(text, replacements || {}),
  };

  return renderRichText(document, mergedOptions);
};

export default RichText;
